export const REQUEST_PENDING_STATUS = 1

export const REQUEST_IN_PROGRESS_STATUS = 2

export const REQUEST_COMPLETED_STATUS = 3

export const REQUEST_DENIED_STATUS = 4

export const REQUEST_STATUS = [
  null,
  {
    backgroundColor: 'var(--color-error-10)',
    text: 'RequestTable.PendingStatusKey',
    textColor: 'var(--color-error)',
  },
  {
    backgroundColor: 'var(--color-in-progress-10)',
    text: 'RequestTable.InProgressStatusKey',
    textColor: 'var(--color-in-progress)',
  },
  {
    backgroundColor: 'var(--color-success-10)',
    text: 'RequestTable.CompletedStatusKey',
    textColor: 'var(--color-success)',
  },
  {
    backgroundColor: 'var(--color-declined-10)',
    text: 'RequestTable.DeniedStatusKey',
    textColor: 'var(--color-declined)',
  },
]

// The `filter` URL param values of the dashboard drill-outs.
export const REQUEST_PRE_FILTER = {
  backlog: 'backlog',
  critical: 'critical',
  mine: 'mine',
  needsInput: 'needs-input',
  overdue: 'overdue',
  unassigned: 'unassigned',
  withoutProvider: 'without-provider',
}

export const REQUEST_OPEN_STATUSES = [
  REQUEST_PENDING_STATUS,
  REQUEST_IN_PROGRESS_STATUS,
]

export const REQUEST_PROFILE_CHANGE_TYPE = {
  activities: 'activities',
  docFlows: 'docFlows',
  documents: 'documents',
  emails: 'emails',
  external: 'external',
  pipeline: 'pipeline',
  posts: 'posts',
  providers: 'providers',
  rating: 'rating',
  relatedRequests: 'relatedRequests',
}

export const REQUEST_PROFILE_TAB_RATING = 'rating'

export const ATTACH_SERVICE_REQUESTS_LOAD_ITEMS_GET_PARAMS = [
  ['with_field', 'flat'],
  ['with_field', 'owner'],
  ['with_field', 'labels'],
  ['with_field', 'building'],
  ['with_field', 'due_date'],
  ['with_field', 'assignees'],
]
